(() => {
  'use strict';
  function recentProductURL(href, origin, root) {
    try {
      const url = new URL(href, origin);
      const match = url.pathname.match(/(?:^|\/)products\/([^/]+)\/?$/);
      if (url.origin !== origin || !match) return null;
      const handle = decodeURIComponent(match[1]);
      if (!/^[\p{L}\p{N}_-]+$/u.test(handle)) return null;
      const base = new URL(root, origin);
      if (base.origin !== origin) return null;
      return new URL(base.pathname.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle), origin);
    } catch { return null; }
  }
  function recentMetadata(product, context) {
    const mode = context.mode || 'collection';
    if (context.allowed === false || !['store', 'collection', 'tag_search'].includes(mode) || !Array.isArray(product?.tags) || !Number.isFinite(product.price) || product.price < 0) return null;
    if (mode === 'store') {
      if (context.allowed !== true || !context.storeKey) return null;
    } else if (!context.country || !product.tags.includes(context.country)) return null;
    let category = 'daily';
    if (product.tags.includes('Joints')) category = 'joints';
    else if (product.tags.includes('Varicose')) category = 'circulation';
    else if (['Prostatitis','Potency','Normalization of sexual function'].some(tag => product.tags.includes(tag))) category = 'men';
    const money = cents => new Intl.NumberFormat(context.locale, {style:'currency', currency:context.currency}).formatToParts(cents / 100)
      .map(part => part.type === 'currency' && context.symbol ? context.symbol : part.value).join('');
    return {category:context.categories[category], price:money(product.price), compare:product.compare_at_price > product.price ? money(product.compare_at_price) : null,
      sale:product.compare_at_price > product.price ? Math.round((1 - product.price / product.compare_at_price) * 100) : 0};
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = { recentProductURL, recentMetadata }; return; }
  const upgrade = () => {
    const grid = document.querySelector('#recentlyViewedGrid');
    const data = document.querySelector('#hlx-recent-card-data');
    const labelData = document.querySelector('#hlx-recent-card-labels');
    if (!grid || !data || !labelData) return;
    const products = JSON.parse(data.textContent);
    const labels = JSON.parse(labelData.textContent);
    const context = {country:data.dataset.countryTag, mode:data.dataset.catalogMode, storeKey:data.dataset.storeKey, allowed:data.dataset.marketAllowed === 'true', locale:data.dataset.locale || document.documentElement.lang || undefined,
      currency:data.dataset.currency, symbol:data.dataset.currencySymbol, categories:labels.categories};
    if (!context.allowed || !context.storeKey || !['store', 'collection', 'tag_search'].includes(context.mode)) return;
    const icon = document.querySelector('#hlx-recent-card-icon');
    const pending = new WeakSet();
    const requests = new Map();
    function metadata(url) {
      const known = products[url.pathname] || products[url.pathname.replace(new URL(data.dataset.rootUrl, location.origin).pathname.replace(/\/?$/, '/'), '/')];
      if (known) return Promise.resolve(known);
      if (!requests.has(url.href)) requests.set(url.href, fetch(url.pathname + '.js', {credentials:'same-origin', headers:{Accept:'application/json'}})
        .then(response => response.ok && (!response.url || new URL(response.url).origin === location.origin) ? response.json() : null).then(product => product ? recentMetadata(product,context) : null).catch(() => null));
      return requests.get(url.href);
    }
    async function renderCard(old) {
      if (pending.has(old)) return;
      pending.add(old);
      const wrapper = old.closest('.card-wrapper');
      const url = recentProductURL(old.getAttribute('href'), location.origin, data.dataset.rootUrl);
      if (!wrapper) return;
      wrapper.hidden = true;
      if (!url) return;
      const image=old.querySelector('img'), heading=old.querySelector('h3'), price=old.querySelector('.price p');
      if (!image || !heading || !price) return;
      const details = await metadata(url);
      if (!details || !old.isConnected) return;
      const article=document.createElement('article'); article.className='hlx-parity-card product-card';
      const link=document.createElement('a'); link.href=url.pathname;
      const media=document.createElement('div'); media.className='hlx-card-image'; media.append(image);
      if (details.sale) { const badge=document.createElement('span'); badge.className='hlx-card-badge'; badge.textContent=`−${details.sale}%`; media.prepend(badge); }
      link.append(media);
      const category=document.createElement('span'); category.className='hlx-card-category'; category.textContent=details.category; link.append(category);
      link.append(heading); price.className='hlx-card-price'; price.textContent=details.price;
      if (details.compare) { const compare=document.createElement('s'); compare.textContent=details.compare; price.append(compare); }
      link.append(price);
      const cta=document.createElement('a'); cta.href=url.pathname; cta.className='hlx-card-cta'; cta.textContent=labels.cta; cta.append(icon.content.cloneNode(true));
      article.append(link,cta); wrapper.replaceWith(article);
    }
    function render() { grid.querySelectorAll('a.card.product-card:not(.hlx-recent-upgraded)').forEach(old => { void renderCard(old); }); }
    render(); new MutationObserver(render).observe(grid,{childList:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',upgrade); else upgrade();
})();
